import Config from './config';

export default class UidWebGatewayApiClient {

  constructor() {
    this.gatewayApiUrlBase = Config.UID_WEB_GATEWAY_API.URL_BASE;
  }

  getMemberRank() {
    const url = new URL('/v1/global-navigation/my-member-rank', this.gatewayApiUrlBase);

    return fetch(url.toString(), {
      mode: 'cors',
      credentials: 'include'
    }).then((response) => {
      if (!response.ok) {
        throw new Error(response.status + ' ' + response.statusText);
      }
      return response.json();
    });
  }
}
